import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { AmplitudeService } from '@inyova/inyova-shared';
import { Customer } from '@inyova/models';

import { Store } from '@ngrx/store';
import { interval, Observable, of, startWith } from 'rxjs';
import { distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import * as AppRootActions from '@app/app.actions';
import * as fromAppRoot from '@app/app.reducers';

import { TrackingService } from '@shared/services/tracking.service';

@Component({
  selector: 'app-verify-email',
  standalone: false,
  templateUrl: './verify-email.component.html',
  styleUrl: './verify-email.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VerifyEmailComponent implements OnInit {
  readonly store = inject(Store);
  readonly trackingService: TrackingService = inject(TrackingService);
  readonly amplitudeService: AmplitudeService = inject(AmplitudeService);

  customer$: Observable<Customer> = this.store.select(fromAppRoot.selectCustomer);
  resendSubmitted$: Observable<boolean> = this.store.select(fromAppRoot.selectResendSubmitted);
  cooldownUntil$: Observable<number | null> = this.store.select(fromAppRoot.selectCooldownUntil);

  cooldownUntilSeconds$ = this.cooldownUntil$.pipe(
    switchMap((cooldownUntil) => {
      if (!cooldownUntil) {
        return of(null);
      }

      return interval(1000).pipe(
        startWith(0),
        map(() => Math.ceil((cooldownUntil - Date.now()) / 1000)),
        map((seconds) => (seconds > 0 ? seconds : null)),
        distinctUntilChanged()
      );
    })
  );

  ngOnInit(): void {
    this.store.dispatch(AppRootActions.loadResendEmailCooldown());
  }

  onResendEmail(customerId: number) {
    this.trackingService.trackActivity('[Button] Resend verification email');
    this.amplitudeService.trackEvent('Email Confirmation Requested', {
      send_reason: 'manual_resend'
    });
    this.store.dispatch(AppRootActions.resendVerificationEmail(customerId));
  }
}
